import * as Turbo from '@hotwired/turbo'
import 'sneat-bootstrap-html-admin-template-free/assets/vendor/libs/jquery/jquery.js'
import 'sneat-bootstrap-html-admin-template-free/assets/vendor/libs/popper/popper.js'
import 'sneat-bootstrap-html-admin-template-free/assets/vendor/js/bootstrap.js'
import 'sneat-bootstrap-html-admin-template-free/assets/vendor/js/helpers.js'
import "@rails/actiontext"
import "trix"

import initDynamicTable from "../scripts/dynamic_table.js"
import initAjaxForm from "../scripts/ajax_form.js"

import Choices from 'choices.js';
// import consumer from "./consumer"

// import "chartkick/chart.js"

Turbo.start()
document.addEventListener("turbo:load", onLoad);
document.addEventListener("turbo:submit-end", onLoad);
let menu, animate;
function onLoad() {

  const params = new URLSearchParams(window.location.search);
  const targetId = params.get('scroll_to');

  if (targetId) {
    const element = document.getElementById(targetId);

    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  
  initAjaxForm()

  let menuToggler = document.querySelectorAll('.layout-menu-toggle');
  menuToggler.forEach(item => {
    item.addEventListener('click', event => {
      event.preventDefault();
      window.Helpers.toggleCollapsed();
    });
  });

  const eyeOpenSVG = `
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  `;

  const eyeClosedSVG = `
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.77 21.77 0 0 1 5.06-6.94"/>
      <path d="M1 1l22 22"/>
      <path d="M9.53 9.53A3.5 3.5 0 0 0 12 15.5a3.5 3.5 0 0 0 2.47-.97"/>
      <path d="M14.47 14.47A3.5 3.5 0 0 0 9.53 9.53"/>
      <path d="M12 4c7 0 11 8 11 8a21.78 21.78 0 0 1-4.21 5.11"/>
    </svg>
  `;

  document.querySelectorAll('input[type="password"]').forEach(input => {
    // Wrapper
    const wrapper = document.createElement("div");
    wrapper.style.position = "relative";
    wrapper.style.display = "inline-block";
    wrapper.style.width = "100%";

    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(input);

    // Icon Button
    const toggleBtn = document.createElement("button");
    toggleBtn.type = "button";
    toggleBtn.innerHTML = eyeOpenSVG;
    toggleBtn.style.position = "absolute";
    toggleBtn.style.right = "10px";
    toggleBtn.style.top = "50%";
    toggleBtn.style.transform = "translateY(-50%)";
    toggleBtn.style.border = "none";
    toggleBtn.style.background = "transparent";
    toggleBtn.style.cursor = "pointer";
    toggleBtn.style.padding = "0";
    toggleBtn.style.color = "rgb(170 170 170)";
    toggleBtn.tabIndex = -1;
    toggleBtn.setAttribute("aria-label", "Passwort anzeigen");
    toggleBtn.setAttribute("aria-pressed", "false");

    wrapper.appendChild(toggleBtn);

    toggleBtn.addEventListener("mousedown", (e) => {
      e.preventDefault();
    });

    toggleBtn.addEventListener("click", () => {
      const isPassword = input.type === "password";
      input.type = isPassword ? "text" : "password";
      toggleBtn.innerHTML = isPassword ? eyeClosedSVG : eyeOpenSVG;
      toggleBtn.setAttribute("aria-pressed", isPassword ? "true" : "false");
      toggleBtn.setAttribute(
        "aria-label",
        isPassword ? "Passwort verbergen" : "Passwort anzeigen"
      );
    });
  });

  let selectSwitch = document.querySelectorAll('.select-switch');
  selectSwitch.forEach(button => {
    button.addEventListener('click', () => {
      let select = document.getElementsByClassName(button.id+"_1")[0]
      let input = document.getElementsByClassName(button.id+"_2")[0]
      if (select.classList.contains("hidden")){
        select.classList.remove("hidden")
        input.classList.add("hidden")
        select.name = input.name
        input.name = "select_input__" + input.name
        button.innerHTML = "+"
      }else{
        select.classList.add("hidden")
        input.classList.remove("hidden")
        input.name = select.name
        select.name = "select_input__" + select.name
        button.innerHTML = "-"
      }
    })
  })

  const copyButtons = document.querySelectorAll(".btn-copy");

  copyButtons.forEach(button => {
    button.addEventListener("click", async () => {
      const content = button.dataset.content; // Inhalt aus data-content holen
      try {
        await navigator.clipboard.writeText(content); // In Zwischenablage kopieren
      } catch (err) {
        console.error("Fehler beim Kopieren:", err);
      }
    });
  });

  const dateModalButtons = document.querySelectorAll(".date-modal-button");

  dateModalButtons.forEach(button => {
    button.addEventListener("click", async () => {
      document.getElementById("daily_offer_id").value = button.dataset.id || ""
      if (button.dataset.product_id) window.choices["daily_offer_product_id"].setChoiceByValue(button.dataset.product_id)

      document.getElementById("daily_offer_date").value = button.dataset.date
    })
  })

  const buttons = document.querySelectorAll(".changeableButton");

  buttons.forEach(button => {
    const idsAttr = button.dataset.changedIds;
    if (!idsAttr) return;

    const inputIds = idsAttr.split(",").map(id => id.trim());
    const inputs = inputIds
      .map(id => document.getElementById(id))
      .filter(Boolean);

    // Initialwerte NUR für diesen Button speichern
    const initialValues = new Map();
    inputs.forEach(input => {
      initialValues.set(input, input.value);
    });

    const updateButtonState = () => {
      const hasChanged = inputs.some(input => {
        return input.value !== initialValues.get(input);
      });

      button.disabled = !hasChanged;
    };

    // Listener nur auf die relevanten Inputs
    inputs.forEach(input => {
      input.addEventListener("input", updateButtonState);
      input.addEventListener("change", updateButtonState);
    });

    // Initialzustand setzen
    updateButtonState();
  });

  window.choices = {}

  function calcInput(input){
    document.getElementById(input.dataset.target).value = Math.round((parseFloat(input.dataset.amount) - parseFloat(input.value)) * 100) / 100
  }

  let calcInputs = document.querySelectorAll('.calc-input');
  calcInputs.forEach(e => {
    e.addEventListener('input', (event) => {
      calcInput(e)
    })
    calcInput(e)
  })
  
  let searchSelects = document.querySelectorAll('.search-select');
  searchSelects.forEach(function (select) {
    window.choices[select.id] = new Choices(select, {
      searchEnabled: true,
      removeItemButton: false,
      placeholderValue: 'Bitte auswählen...',
      itemSelectText: "auswählen",
      noResultsText: "Keine Einträge gefunden",
      shouldSort: false,
      allowHTML: true,
    });

    if (select.classList.contains("submit-on-change")){
      select.addEventListener('change', function(event) {
        setTimeout(() => {
          select.closest('form').submit()
        }, 500);
      }, false);
    }
  })

  let selects = document.querySelectorAll('.create-select');
  selects.forEach(function (select) {
    const newCustomerFields = document.getElementById(select.id+"_fields");
    function toggleCustomerFields() {
      if (!newCustomerFields){
        console.log("Can not find: #"+select.id+"_fields")
        return false
      }
      if (select.value === "0") {
        newCustomerFields.style.display = "block";
      } else {
        newCustomerFields.style.display = "none";
      }
    }

    select.addEventListener("change", toggleCustomerFields);
    toggleCustomerFields(); // initialer Zustand

    let o=select.querySelector('option[value="0"]');
    let a=document.createElement('a');
    a.href="#";a.textContent=o.text;
    a.style="font-size: 90%;margin: 5px; display: block";
    a.onclick=e=>{
      e.preventDefault();
      window.choices[select.id].removeActiveItems();
      window.choices[select.id].setChoiceByValue('0')
      toggleCustomerFields();
    };
    select.after(a);

    let m1=select.querySelector('option[value="-1"]');
    if (m1){
      let a1=document.createElement('a');
      a1.href="#";a1.textContent=m1.text;
      a1.style="font-size: 90%;margin: 5px; display: block";
      a1.onclick=e=>{
        e.preventDefault();
        window.choices[select.id].removeActiveItems();
        window.choices[select.id].setChoiceByValue('-1')
        toggleCustomerFields();
      }; 
      a.after(a1);
    }

    window.choices[select.id] = new Choices(select, {
      searchEnabled: true,
      removeItemButton: false,
      placeholderValue: 'Bitte auswählen...',
      itemSelectText: "auswählen",
      noResultsText: "Keine Einträge gefunden",
      shouldSort: false,
    });

  })

  let multipleSelect = document.querySelectorAll('.multiple-select');
  multipleSelect.forEach(function (select) {
    window.choices[select.id] = new Choices(select, {
      searchEnabled: true,
      removeItemButton: true,
      placeholderValue: 'Bitte auswählen...',
      noResultsText: "Keine Einträge gefunden",
      itemSelectText: "auswählen",
      shouldSort: false,
    });
  })

  window.order_item_price = (row) => Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format((parseFloat(row.price)||0));
  window.order_item_total = (row) => Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format((parseFloat(row.price)||0)*(parseFloat(row.quantity)||0));
  window.order_item_quantity = (row) => (parseFloat(row.quantity)||0)+"x";
  window.order_item_title = (row) => row.title+"<div><small class='text-muted'>"+row.subtitle+"</small></div>";
  window.order_item_tax = (row) => (parseInt(row.tax)||0)+"%";

  document.querySelectorAll('.js-dynamic-table').forEach(initDynamicTable);

  let reloadPage = document.querySelectorAll('#reload-page');
  reloadPage.forEach(function (element) {
    setInterval(() => {
      location.reload();
    }, 5 * 60 * 1000);
  });

  let fadeOutBoxs = document.querySelectorAll('#fadeOutBox');
  fadeOutBoxs.forEach(function (element) {
    setTimeout(() => {
      element.classList.add("fade-out");
    }, 3 * 1000);
  });

  // let layoutMenuToggle = document.querySelectorAll('.layout-menu-toggle a');
  // layoutMenuToggle.forEach(function (element) {
  //   element.addEventListener('click', () => {
  //     let menu = document.querySelector('#layout-menu')
  //     menu.classList.toggle('layout-menu');
  //   })
  // });

  let fileInputs = document.querySelectorAll('input.form-control.file');
  fileInputs.forEach(input => {
    const previewImg = document.querySelector('#preview-image-'+input.id)
    if (previewImg) {
      input.onchange = evt => {
        const [file] = input.files
        if (file) {
          previewImg.src = URL.createObjectURL(file)
        }
      }
    }
  })

  // // Display menu toggle (layout-menu-toggle) on hover with delay
  // let delay = function (elem, callback) {
  //   let timeout = null;
  //   elem.onmouseenter = function () {
  //     // Set timeout to be a timer which will invoke callback after 300ms (not for small screen)
  //     if (!Helpers.isSmallScreen()) {
  //       timeout = setTimeout(callback, 300);
  //     } else {
  //       timeout = setTimeout(callback, 0);
  //     }
  //   };

  //   elem.onmouseleave = function () {
  //     // Clear any timers set to timeout
  //     document.querySelector('.layout-menu-toggle').classList.remove('d-block');
  //     clearTimeout(timeout);
  //   };
  // };
  // if (document.getElementById('layout-menu')) {
  //   delay(document.getElementById('layout-menu'), function () {
  //     // not for small screen
  //     if (!Helpers.isSmallScreen()) {
  //       document.querySelector('.layout-menu-toggle').classList.add('d-block');
  //     }
  //   });
  // }

  // Display in main menu when menu scrolls
  let menuInnerContainer = document.getElementsByClassName('menu-inner'),
    menuInnerShadow = document.getElementsByClassName('menu-inner-shadow')[0];
  if (menuInnerContainer.length > 0 && menuInnerShadow) {
    menuInnerContainer[0].addEventListener('ps-scroll-y', function () {
      if (this.querySelector('.ps__thumb-y').offsetTop) {
        menuInnerShadow.style.display = 'block';
      } else {
        menuInnerShadow.style.display = 'none';
      }
    });
  }

  // Init helpers & misc
  // --------------------

  // Init BS Tooltip
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  // Accordion active class
  const accordionActiveFunction = function (e) {
    if (e.type == 'show.bs.collapse' || e.type == 'show.bs.collapse') {
      e.target.closest('.accordion-item').classList.add('active');
    } else {
      e.target.closest('.accordion-item').classList.remove('active');
    }
  };

  const accordionTriggerList = [].slice.call(document.querySelectorAll('.accordion'));
  const accordionList = accordionTriggerList.map(function (accordionTriggerEl) {
    accordionTriggerEl.addEventListener('show.bs.collapse', accordionActiveFunction);
    accordionTriggerEl.addEventListener('hide.bs.collapse', accordionActiveFunction);
  });

  // Auto update layout based on screen size
  window.Helpers.setAutoUpdate(true);

  // Toggle Password Visibility
  window.Helpers.initPasswordToggle();

  // Manage menu expanded/collapsed with templateCustomizer & local storage
  //------------------------------------------------------------------

  // If current layout is horizontal OR current window screen is small (overlay menu) than return from here
  // if (window.Helpers.isSmallScreen()) {
  //   return;
  // }

  // If current layout is vertical and current window screen is > small

  // Auto update menu collapsed/expanded based on the themeConfig
  window.Helpers.setCollapsed(true, false);


  let submitOnChange = document.querySelectorAll('.submit-on-change');
  submitOnChange.forEach(select => {
  let isOpen = false;
  let valueAtOpen = null;

  function submitForm() {
    setTimeout(() => {
      select.closest('form').submit();
    }, 100);
  }

  select.addEventListener('change', function() {
    isOpen = false;
    submitForm();
  });

  select.addEventListener('click', function() {
    if (!isOpen) {
      // Dieser Klick öffnet das Dropdown
      isOpen = true;
      valueAtOpen = select.value;
    } else {
      // Dieser Klick schließt das Dropdown (gleiche Option gewählt)
      isOpen = false;
      if (select.value === valueAtOpen) {
        submitForm();
      }
    }
  });

  // Falls per Escape/Klick-außerhalb abgebrochen wird, Flag zurücksetzen
  select.addEventListener('blur', function() {
    isOpen = false;
  });
  })
  
  function checkCheckSwitchs(input){
    console.log('.content_'+input.id)
    document.querySelectorAll('.content_'+input.id).forEach(content => {
      if (input.checked){
        content.classList.remove("d-none")
      }else{
        content.classList.add("d-none")
      }
    })
    document.querySelectorAll('.content_negativ_'+input.id).forEach(content => {
      if (input.checked){
        content.classList.add("hidden")
      }else{
        content.classList.remove("hidden")
      }
    })
  }

  window.mealDayCount = 0
  let mealButtons = document.querySelectorAll('.meal-button');
  mealButtons.forEach(button => {
    button.addEventListener('click', () => {
      if (button.classList.contains("meal-next")) window.mealDayCount -= 1
      if (button.classList.contains("meal-prev")) window.mealDayCount += 1
      fetch("/api/meal/"+window.mealDayCount+"/"+button.dataset.token).then((response) => response.text()).then((html) => {
        document.querySelector('.meal-content').innerHTML = html
      })
    })
  })

  let menuToggles = document.querySelectorAll('.menu-toggle');
  menuToggles.forEach(button => {
    button.addEventListener('click', () => {
      button.parentElement.classList.toggle('open')
    })
  })

  let checkSwitchs = document.querySelectorAll('.checkSwitch');
  checkSwitchs.forEach(input => {
    checkCheckSwitchs(input)
    input.addEventListener('input', () => {
      checkCheckSwitchs(input)
    })
  })

  const toggleSelectsInnerFunction = function (e) {
    document.querySelectorAll('.content_'+e.id).forEach(ee => {
      ee.classList.add("d-none")
    })
    document.querySelectorAll('.content_'+e.id+'_'+e.value).forEach(ee => {
      ee.classList.remove("d-none")
    })
  }

  let toggleSelects = document.querySelectorAll('.toggle-select');
  toggleSelects.forEach(e => {
    toggleSelectsInnerFunction(e)
    e.addEventListener('change', (event) => {
      toggleSelectsInnerFunction(e)
    })
  })

  let clearButtons = document.querySelectorAll('.clear-button');
  clearButtons.forEach(e => {
    e.addEventListener('click', (event) => {
      e.parentElement.querySelectorAll('.form-select').forEach(s => {
        s.value = "" 
      })
    })
  })

  let asyncButtons = document.querySelectorAll('.async-button');
  asyncButtons.forEach(e => {
    e.addEventListener('click', (event) => {
      event.preventDefault();

      let params

      if (document.getElementById(e.id.replace("-btn", "-input"))){
        params = JSON.stringify({input: document.getElementById(e.id.replace("-btn", "-input")).value})
      }
      
      fetch(e.dataset.url, {
        method: e.dataset.method || 'DELETE',
        body: params,
        headers: {
          "X-CSRF-Token": e.dataset.authenticityToken,
          "Content-Type": "application/json"
        }
      }).then(r => r.json())
        .then(data => {
          if (data.reload) {
            location.reload();
          } else if (data.redirect_to) {
            window.location.href = data.redirect_to
          }
        })
    })
  })
}